import { Component, OnInit } from "@angular/core";

import { AppConfigService } from "./core/services/app-config.service";
import * as $ from "jquery";
import { CAPService } from "./core/services/cap-service";
import { RebarAuthService } from "./core/rebarauth/rebar.auth.service";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import * as moment from "moment";
// import { datadogRum } from '@datadog/browser-rum';
// import { DatadogSessionService } from './core/services/datadog-session.service';
import { Console } from "console";
import { Buffer } from "buffer";
import { buffer } from "stream/consumers";

declare let IM_CLD_CentRum: any;

declare global {
  interface Window {
    _paq: any;
  }
}
window._paq = window._paq || [];

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  providers: [CAPService],
})
export class AppComponent implements OnInit {
  title = "Call Accounting Portal";

  public LoggedInEnterpriseId = "";
  ProfileImage = false;
  EmptyImage = false;
  IsAdmin = false;
  IsReports = false;
  IsAuthcode = false;
  IsPay = false;
  IsLogin = false;
  ProfilePicURL;
  isVisible = false;
  popUpModel = "none";
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  getUser;
  // EnterpriseId;
  CopyrightYear;

  //homecomponent variables
  IsCountryCarousel = false;
  IsTrunkCarousel = false;
  IsGatewayCarousel = false;
  IsCAPCarousel = false;
  IsprojectCarousel = false;
  IsGlobalCarousel = false;
  IsCountryDashboard = false;
  IsTrunkDashboard = false;
  IsGatewayDashboard = false;
  IsCAPDashboard = false;
  IsProjectSDashboard = false;
  IsGlobalDashboard = false;
  IsRegionalDashboard = false;
  IsRegionalCarousel = false;

  IsConfig = false;
  IsGateway = false;
  IsCallRates = false;
  IsCallRules = false;
  IsTelco = false;
  IsCurrencyConversion = false;
  IsCountryCodeConfiguration = false;
  IsDevice = false;
  IsCAPMap = false;
  IsDailInConference = false;
  IsProject = false;
  IsEngineer = false;
  IsDestination = false;
  IsSchedulerReport = false; //2023
  //  datadogRUMId: any;
  // rebarAuthService: any; // MSAL V2

  Role;
  configData;
  alertcomponent;
  modalcomponent;
  toastcomponent;

  constructor(
    private appConfigService: AppConfigService,
    private CAPService: CAPService,
    private auth: RebarAuthService,
    private rebarAuthService: RebarAuthService,
    private idle: Idle,
    private keepalive: Keepalive,
    public router: Router
  ) {
    this.LoggedInEnterpriseId = CAPService.enterpriseid;
    this.configData = appConfigService.getConfig()["notification"];

    //  this.datadogRUMId = appConfigService.getConfig()["datadog"];

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(840);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      this.LogOff();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      this.popUpModel = "block";
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "Session Expires in " + countdown + " second(s).";
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();

    this.CopyrightYear = moment().format("YYYY");
  }
  ngOnInit() {
    this.alertcomponent = this.configData.alerts;
    this.modalcomponent = this.configData.modal;
    this.toastcomponent = this.configData.toast;

    // if (!this.auth.authenticationEnabled()) this.isVisible = true;

    // if (this.auth.authenticationEnabled() && this.auth.isUserAuthenticated())
    //   this.isVisible = true;
    // if (!this.auth.authenticationEnabled()) {
    //   this.isVisible = true;
    // }
    // //MSAL V2 - changed to isUserAuthenticated() from IsUserAuthenticated()
    // if (this.auth.authenticationEnabled() && this.auth.isUserAuthenticated()) {
    //   this.isVisible = true;

    //   window.addEventListener("hashchange", this.onhashchange);
    //   this.router.events
    //     .pipe(filter((e) => e instanceof NavigationEnd))
    //     .subscribe((event: NavigationEnd) => {
    //       // console.log(event);
    //       // console.log('Route Change Successful');
    //
    //       // this.getUser = this.auth.getUser().userName.split('@');
    //       // this.EnterpriseId = this.getUser[0];
    //
    //       // console.log(this.EnterpriseId);
    //       // console.log('5142020Edit');
    //     });
    // }

    const nav = $(".header-main");
    $(document).ready(function () {
      const navoffeset = (nav.offset() || { top: NaN }).top;

      $(window).scroll(function () {
        const scrollpos = $(window).scrollTop();
        if (scrollpos >= navoffeset) {
          $(".header-main").addClass("fixed");
        } else {
          $(".header-main").removeClass("fixed");
        }
      });
      $("#scroll_navigation ul li").on("click", function () {
        $(window).scrollTop(0);
      });
      $("#foot div").on("click", function () {
        $(window).scrollTop(0);
      });

      addEventListener(
        "load",
        function () {
          setTimeout(hideURLbar, 0);
        },
        false
      );
      function hideURLbar() {
        window.scrollTo(0, 1);
      }
      const selectedRecordCriteria = "All";
      document.addEventListener("contextmenu", function (e) {
        alert("The right click options are disabled for this window");
        return false;
      });
      // window.onpopstate = function (e) { window.history.forward(1); }

      let toggle = true;
      $(".page-container")
        .addClass("sidebar-collapsed") // closed
        .removeClass("sidebar-collapsed-back");
      $(".sidebar-icon").click(function () {
        if (toggle) {
          $(".page-container")
            .removeClass("sidebar-collapsed")
            .addClass("sidebar-collapsed-back"); // open
          $("#menu span").css({ position: "relative" });
        } else {
          $(".page-container")
            .addClass("sidebar-collapsed") // close
            .removeClass("sidebar-collapsed-back");
          setTimeout(function () {
            $("#menu span").css({ position: "relative" });
          }, 1000);
        }
        toggle = !toggle;
      });
    });

    this.router.navigateByUrl("");

    this.auth.authObserver$.subscribe((authStatus) => {
      if (authStatus) {
        console.log(`user is logged in ${authStatus}`);
        console.log(`Username ****** ${this.auth.getUser()}`);

        //Add these 2 lines of code for storing the User Token Claims in the session Storage
        const userTokenClaims = JSON.stringify(
          this.rebarAuthService.getUserClaims()
        );
        const parsedClaims = JSON.parse(userTokenClaims);
        const payload = {
          businessOrg: parsedClaims.businessOrg,
          countryDescription: parsedClaims.countryDescription,
          countryCode: parsedClaims.countryCode,
          jobTitle: parsedClaims.jobTitle,
          jobFamily: parsedClaims.jobFamily,
          location: parsedClaims.location,
          locationCode: parsedClaims.locationCode,
          jobFamilyDescription: parsedClaims.jobFamilyDescription,
        };
        //Set Item to Session Storage
        sessionStorage.setItem("ddrumsdk.tokenclaims", JSON.stringify(payload));

        if (
          this.auth.authenticationEnabled() &&
          this.auth.isUserAuthenticated()
        ) {
          this.isVisible = true;
          window.addEventListener("haschange", this.onhashchange);
          this.router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
              // console.log(event);
            });
        }
      }
    });

    //Datadog Init
    IM_CLD_CentRum(this).log({
      applicationId: (
        this.appConfigService.config["datadog"] as Record<string, string>
      )["appid"],
      clientToken: (
        this.appConfigService.config["datadog"] as Record<string, string>
      )["clienttoken"],
      service: (
        this.appConfigService.config["datadog"] as Record<string, string>
      )["service"],
      env: (this.appConfigService.config["datadog"] as Record<string, string>)[
        "environment"
      ],
      sampleRate: 100,
      trackInteractions: true,
      allowedTracingOrigins: (
        this.appConfigService.config["datadog"] as Record<string, string>
      )["allowedtracingoriginsdns"],
      useSecureSessionCookie: true,
    });

    //   datadogRum.init({
    //   applicationId:  (this.appConfigService.config['datadog'] as Record<string, string>)['appId'],
    //   clientToken: (this.appConfigService.config["datadog"] as Record<string, string>)['clientToken'],
    //   site: 'datadoghq.com',
    //   service:(this.appConfigService.config["datadog"] as Record<string, string>)['service'],
    //   env:(this.appConfigService.config["datadog"] as Record<string, string>)['environment'],
    //   sampleRate: 100,
    //   trackInteractions: true,
    //   allowedTracingOrigins:[(this.appConfigService.config["datadog"] as Record<string, string>)['allowedTracingOriginsDNS']],
    //   useSecureSessionCookie: true,
    // });
    // datadogRum.setUser({ id: this.datadogSessionService.setDataDogSessionId() });

    // this.appConfigService.DatadogRUMInit(
    //   this.datadogRUMId.clientToken,
    //   this.datadogRUMId.applicationId,
    //   this.datadogRUMId.site,
    //   this.datadogRUMId.service,
    //   this.datadogRUMId.env
    // );
  }
  //PIWIK method call
  onhashchange() {
    //throw new Error("Method not implemented.");
    window._paq.push(["setCustomUrl", "/" + window.location.hash.substr(1)]);
    window._paq.push(["setDocumentTitle", "Popup"]);
    window._paq.push(["setUserId"]);
    window._paq.push(["trackPageView"]);
  }

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }
  stay() {
    this.reset();
    this.popUpModel = "none";
  }
  LogOff() {
    window.sessionStorage.setItem("primaryLoggedIn", "");
    this.auth.logout(); //MSAL V2
  }
  MenuRoleforUser() {
    debugger;
    this.IsAdmin = false;
    this.IsReports = false;
    this.IsAuthcode = false;
    this.IsPay = false;

    //this.IsLogin = false;

    this.CAPService.GetRoles(
      "N",
      //this.CAPService.enterpriseid,
       encodeURIComponent(this.CAPService.enterpriseid),
      
      "RolesDetails"
    ).subscribe((data) => {
      if (data.toString() == "Unauthorized Access") {
        alert("Unauthorized Access 404");
      } else {
        this.Role = { RolesData: data, selected: {} };
        //this.dataLoader = false;
        if (this.Role.RolesData.length > 0) {
          this.Role.RolesData.forEach((data) => {
            this.CAPService.Role = data.rolename;
            this.CAPService.UserCountry = data.Country;

            //  if (this.CAPService.country == 'India' && this.CAPService.Role != 'Global Admin') {
            //     window.location.href ='https://mycalls-india.accenture.com';
            // }

            this.CAPService.DeviceType = data.DeviceType;
            if (data.rolename == "Regional Voice Admin") {
              this.IsConfig = true;
              this.IsGateway = true;
              this.IsCallRates = true;
              this.IsCallRules = true;
              this.IsTelco = true;
              this.IsCurrencyConversion = true;
              this.IsCountryCodeConfiguration = false;
              this.IsDevice = true;
              this.IsCAPMap = true;
              this.IsDailInConference = true;
              this.IsAdmin = true;
              this.IsReports = true;
              this.Action("Regional");
              this.IsPay = true;
              this.IsProject = true;
              this.IsEngineer = true;
              this.IsDestination = true;
              this.IsAuthcode = true;
              this.IsSchedulerReport = true;
            }
            if (data.rolename == "Global Admin") {
              this.IsConfig = true;
              this.IsGateway = true;
              this.IsCallRates = true;
              this.IsCallRules = true;
              this.IsTelco = true;
              this.IsCurrencyConversion = true;
              this.IsCountryCodeConfiguration = true;
              this.IsDevice = true;
              this.IsCAPMap = true;
              this.IsDailInConference = true;
              this.IsAdmin = true;
              this.IsReports = true;
              this.IsGlobalCarousel = true;
              this.IsProject = true;
              this.IsSchedulerReport = true;
              this.IsProjectSDashboard = false;
              this.IsprojectCarousel = false;
              this.Action("Regional");
              this.IsPay = true;
              this.IsGlobalDashboard = true;
              this.IsEngineer = true;
              this.IsDestination = true;
              this.IsAuthcode = true;
            }
            if (data.rolename == "Gateway Access") {
              this.IsConfig = true;
              this.IsGateway = true;
              this.Action("Other");
            }
            if (data.rolename == "Call Rates Access") {
              this.IsConfig = true;
              this.IsCallRates = true;
              this.Action("Other");
            }
            if (data.rolename == "Call Rules Access") {
              this.IsConfig = true;
              this.IsCallRules = true;
              this.Action("Other");
            }
            if (data.rolename == "Telco Access") {
              this.IsConfig = true;
              this.IsTelco = true;
              this.Action("Other");
            }
            if (data.rolename == "Currency Conversion Access") {
              this.IsConfig = true;
              this.IsCurrencyConversion = true;
              this.Action("Other");
            }
            if (data.rolename == "Country Code Configuration Access") {
              this.IsConfig = true;
              this.IsCountryCodeConfiguration = true;
              this.Action("Other");
            }
            if (data.rolename == "Device Access") {
              this.IsConfig = true;
              this.IsDevice = true;
              this.Action("Other");
            }
            if (data.rolename == "CAPM Access") {
              this.IsConfig = true;
              this.IsCAPMap = true;
              this.Action("Other");
            }
            if (
              data.rolename == "Call Charge Report Access" ||
              data.rolename == "Trunk Group Report Access" ||
              data.rolename == "Gateway Group Report Access" ||
              data.rolename == "Group Report" ||
              data.rolename == "CAPM Report Access" ||
              data.rolename == "Recovery Reports" ||
              data.rolename == "Utilization Reports"
            ) {
              // this.IsConfig = false;
              this.IsReports = true;
              this.CAPService.ReportRole = data.rolename;
            }
            if (data.rolename == "RTP Access") {
              // this.IsConfig = false;
              this.IsPay = true;
              this.IsAuthcode = false;
              this.IsReports = true;
              this.Action("Other");
            }
            if (data.rolename == "Engineer Access") {
              // this.IsConfig = false;
              this.IsEngineer = true;
              this.Action("Other");
            }
            if (data.rolename == "Destination Acces") {
              // this.IsConfig = false;
              this.IsDestination = true;
              this.Action("Other");
            }
            if (data.rolename == "Finance Report") {
              // this.IsConfig = false;
              this.IsReports = true;
              this.Action("Other");
              this.CAPService.ReportRole = data.rolename;
              this.CAPService.DeviceType = data.DeviceType;
            }
          });
        }
       }
    });
  }
  Action(type) {
    if (type == "Regional") {
      this.IsRegionalDashboard = true;
      this.IsRegionalCarousel = true;
      //this.dataLoader = false;
    } else if (type == "Other") {
      this.IsRegionalDashboard = false;
      this.IsRegionalCarousel = false;
      this.IsprojectCarousel = false;
      this.IsGlobalCarousel = false;
      this.IsProjectSDashboard = false;
      this.IsGlobalDashboard = false;
      //this.dataLoader = false;
    }
  }
  downloadUserManual() {
    //this.dataLoader = true;

    this.CAPService.GetUserManualDownload("UserManual").subscribe(
      (resultBlob: Blob) => {
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          // for IE
          (window.navigator as any).msSaveOrOpenBlob(
            resultBlob,
            "CallAccountingPortalUserManual.docx"
          );
          //this.dataLoader = false;
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(resultBlob);
          link.download = "CallAccountingPortalUserManual.docx";
          link.click();
          //this.dataLoader = false;
        }
      },
      function (x) {
        console.log(x);
        alert("Acknowledgement failed");
        this.dataLoader = false;
      }
    );

  //   //this.dataLoader = false;
   }
}
